import img1 from "../src/assets/img1.jpeg";
import img2 from "../src/assets/img2.jpeg";
import img3 from "../src/assets/img3.jpeg";
import img4 from "../src/assets/img4.jpeg";
import img5 from "../src/assets/img5.jpeg";
import img6 from "../src/assets/img6.jpeg";
import img7 from "../src/assets/img7.jpeg";
import img8 from "../src/assets/img8.jpeg";
import img9 from "../src/assets/img9.jpeg";
import img10 from "../src/assets/img10.jpeg";
import img11 from "../src/assets/img11.jpeg";
import img12 from "../src/assets/img12.jpeg";
import img13 from "../src/assets/img13.jpeg";
import img14 from "../src/assets/img14.jpeg";
import img15 from "../src/assets/img15.jpeg";
import img16 from "../src/assets/img16.jpeg";
import img17 from "../src/assets/img17.jpeg";
import img18 from "../src/assets/img18.jpeg";
import img19 from "../src/assets/img19.jpeg";
import img20 from "../src/assets/img20.png";
import img21 from "../src/assets/img21.jpeg";
import img22 from "../src/assets/img22.jpeg";
import img23 from "../src/assets/img23.jpeg";
import img24 from "../src/assets/img24.jpeg";
import img25 from "../src/assets/img25.jpeg";
import img26 from "../src/assets/img26.jpeg";
import img27 from "../src/assets/img27.jpeg";
import img28 from "../src/assets/img28.jpeg";
import img29 from "../src/assets/img29.jpeg";
import img30 from "../src/assets/img30.jpeg";
import img31 from "../src/assets/img31.png";
import img32 from "../src/assets/img32.jpeg";
import img33 from "../src/assets/img33.jpeg";
import img34 from "../src/assets/img34.jpeg";
import img35 from "../src/assets/img35.jpeg";
import img36 from "../src/assets/img36.jpeg";
import img37 from "../src/assets/img37.jpeg";
import img38 from "../src/assets/img38.jpeg";
import img39 from "../src/assets/img39.jpeg";
import img40 from "../src/assets/img40.jpeg";

const data = {
  imgData: [
    {
      id: 1,
      img: img1,
      link: "",
    },
    {
      id: 2,
      img: img2,
      link: "",
    },
    {
      id: 3,
      img: img3,
      link: "",
    },
    {
      id: 4,
      img: img4,
      link: "",
    },
    {
      id: 5,
      img: img5,
      link: "",
    },
    {
      id: 6,
      img: img6,
      link: "",
    },
    {
      id: 7,
      img: img7,
      link: "",
    },
    {
      id: 8,
      img: img8,
      link: "",
    },
    {
      id: 9,
      img: img9,
      link: "",
    },
    {
      id: 10,
      img: img10,
      link: "",
    },
    {
      id: 11,
      img: img11,
      link: "",
    },
    {
      id: 12,
      img: img12,
      link: "",
    },
    {
      id: 13,
      img: img13,
      link: "",
    },
    {
      id: 14,
      img: img14,
      link: "",
    },
    {
      id: 15,
      img: img15,
      link: "",
    },
    {
      id: 16,
      img: img16,
      link: "",
    },
    {
      id: 17,
      img: img17,
      link: "",
    },
    {
      id: 18,
      img: img18,
      link: "",
    },
    {
      id: 19,
      img: img19,
      link: "",
    },
    {
      id: 20,
      img: img20,
      link: "",
    },
    {
      id: 21,
      img: img21,
      link: "",
    },
    {
      id: 22,
      img: img22,
      link: "",
    },
    {
      id: 23,
      img: img23,
      link: "",
    },
    {
      id: 24,
      img: img24,
      link: "",
    },
    {
      id: 25,
      img: img25,
      link: "",
    },
    {
      id: 26,
      img: img26,
      link: "",
    },
    {
      id: 27,
      img: img27,
      link: "",
    },
    {
      id: 28,
      img: img28,
      link: "",
    },
    {
      id: 29,
      img: img29,
      link: "",
    },
    {
      id: 30,
      img: img30,
      link: "",
    },
    {
      id: 31,
      img: img31,
      link: "",
    },
    {
      id: 32,
      img: img32,
      link: "",
    },
    {
      id: 33,
      img: img33,
      link: "",
    },
    {
      id: 34,
      img: img34,
      link: "",
    },
    {
      id: 35,
      img: img35,
      link: "",
    },
    {
      id: 36,
      img: img36,
      link: "",
    },
    {
      id: 37,
      img: img37,
      link: "",
    },
    {
      id: 38,
      img: img38,
      link: "",
    },
    {
      id: 39,
      img: img39,
      link: "",
    },
    {
      id: 40,
      img: img40,
      link: "",
    },
  ],
};

export default data;
